export default {
  selectionCount: {
    notes: 'Label for selection count in the action bar, e.g. "3 selected"',
    message: 'selected',
  },
};
